/**
 * 应用基础信息
 */
class AppBaseEntity {
  // 应用APPID
  appId
  // 应用名
  appName
  // 应用菜单
  menus = []
  // 应用token
  token = undefined
  // SSOToken
  ssoToken = undefined
  // userInfo
  userInfo = undefined
  // loginSsoToken
  loginSsoToken = undefined

  constructor({ appId, appName, menus = [], token, ssoToken, userInfo, loginSsoToken }) {
    this.appId = appId
    this.appName = appName
    this.menus = menus
    this.token = token
    this.ssoToken = ssoToken
    this.userInfo = userInfo
    this.loginSsoToken = loginSsoToken
  }
}
export default AppBaseEntity
